var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mit-my-borrowed-list"},[_c('MitDataTableClient',{attrs:{"title":"Borrowed","editable":false,"headers":_vm.headers,"items":_vm.borrowed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }